export interface FeildActivity_Interface {
  id:number,
  code:string
  title:String,
  defaultt:boolean,
  persianDate:String,
  username:String,
  del:boolean,
  DeletingProccess:boolean
}

export function Empty_FeildActivity_Interface(){
  return{
    id:0,
    code:'',
    title:'',
    persianDate:'',
    username:'',
    del:false,
    defaultt:false,
    DeletingProccess:false,
  }
}
